import UploadIcon from "../../../Icon-SVG/UploadIcon";
import TrashBucketIcon from "../../../Icon-SVG/TrashBucketIcon";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RequestGetUILogo,
  RequestSetUILogo,
  RequestDeleteBanner,
} from "../../../../store/actions/dashboardActions";
import "./styles.scss";

const UpdateLogo = () => {
  const dispatch = useDispatch();
  const [bannerLogo, setBannerLogo] = useState("");
  const uiLogo = useSelector((state) => state.dashboard.uiLogo);
  const loadingLogo = useSelector((state) => state.dashboard.loadingLogo);
  var bannerImg = document.getElementById("tableBanner");

  const setViewLogo = (logoSrc) => {
    setBannerLogo(logoSrc);
  };

  useEffect(() => {
    dispatch(RequestGetUILogo());
  }, [loadingLogo]);

  useEffect(() => {
    setBannerLogo("data:image/png;base64," + uiLogo);
  }, [uiLogo]);

  const imageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64StringUS = reader.result.replace("data:", "").replace(/^.+,/, "");
        localStorage.setItem("wallpaperXXX", base64StringUS);
        const myImage = localStorage.getItem("wallpaperXXX");
        bannerImg = document.getElementById("tableBanner");
        setViewLogo("data:image/png;base64," + myImage);
        dispatch(RequestSetUILogo(file));
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select an image file.");
    }
  };

  const DeleteBannerLogo = () => {
    dispatch(RequestDeleteBanner());
  };

  return (
    <div className="updatelogo">
      <table>
        <tbody>
          <tr>
            <td>
              <label htmlFor="imageFile" className="updatelogo--img-upload">
                <UploadIcon color="var(--header-search-text-color)" width={20} height={20} />
                Upload Logo
              </label>
              <input
                className="updatelogo--input"
                type="file"
                id="imageFile"
                placeholder="deneme"
                name="imageFile"
                onChange={imageUpload}
              />
            </td>
          </tr>
          <tr>
            <td>
              <img
                alt=""
                id="tableBanner"
                className="updatelogo--img"
                src={uiLogo ? bannerLogo : "/BrandIcons/DefaultLogoIcon.png"}
              />
            </td>
          </tr>
          <tr>
            <td>
              <span className="updatelogo--img-delete" onClick={() => DeleteBannerLogo()}>
                <TrashBucketIcon color="red" width={20} height={20} />
                Delete Logo
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UpdateLogo;
